export default __webpack_public_path__ + "resources/icons/d441-34b2.png";